export const getPhotosWithRadiographs = (file, isInSimulation = false) => {
    try {
        if (typeof file !== 'object' || file === null) {
            throw new Error('Invalid input: file must be a non-null object');
        }

        const entries = Object.entries(file);
        const photos = entries
            .filter(([key]) => {
                if (isInSimulation) {
                    return (
                        (key.startsWith('photo') && file[`${key}_later`] === false) ||
                        (key.startsWith('radio') && file[`${key}_later`] === false)
                    );
                }
                return (key.startsWith('photo') && file[`${key}_later`] === false) || key === 'facial_scan_file';
            })
            .filter(([key]) => !key.endsWith('later'));
        return photos;
    } catch (error) {
        console.error('Error in getPhotosWithRadiographs:', error.message);
        return [];
    }
};

export const progress_photo_angles = ['left', 'front', 'right'];

export const baseSupportImgObj = {
    data_url: '',
    subject: '',
    imgData: null,
};

export const initCaseSupportingImgs = [baseSupportImgObj, baseSupportImgObj, baseSupportImgObj];
